/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wait: NonNullable<unknown> }} Feedback_Submit_WaitInputs */



/**
* | output |
* | --- |
* | "Send ({wait})" |
*
* @param {Feedback_Submit_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_submit_wait = /** @type {((inputs: Feedback_Submit_WaitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Submit_WaitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Envoyer (${i?.wait})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Enviar (${i?.wait})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Enviar (${i?.wait})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Invia (${i?.wait})`)
	return /** @type {LocalizedString} */ (`Send (${i?.wait})`)
});